// Entegrasyonlar, API, ekip, roller, denetim (C74–C79): Control yönlendirmeleri (izin + bayrak korumalı, tembel yüklenir).
import { Route } from 'react-router';
import { guard, load } from '../route-utils';

const Integrations = load(() => import('./Integrations'), 'Integrations');
const ApiAccess = load(() => import('./ApiKeys'), 'ApiAccess');
const Team = load(() => import('./Team'), 'Team');
const TeamInvite = load(() => import('./TeamInvite'), 'TeamInvite');
const Roles = load(() => import('./Roles'), 'Roles');
const AuditLog = load(() => import('./AuditLog'), 'AuditLog');

export const systemRoutes = (
  <>
    <Route path="entegrasyonlar" element={guard(Integrations, 'integrations')} />
    <Route path="entegrasyonlar/api" element={guard(ApiAccess, 'integrations', { flag: 'API' })} />
    <Route path="ekip" element={guard(Team, 'team')} />
    <Route path="ekip/davet" element={guard(TeamInvite, 'team', { action: 'edit' })} />
    <Route path="ekip/roller" element={guard(Roles, 'team')} />
    <Route path="denetim-kaydi" element={guard(AuditLog, 'audit')} />
  </>
);
